import ABCyaLib from "@abcya/abcya_lib";
import ABCyaPhaser from "@abcya/abcya_phaser";
import FontKeys from "../../FontKeys";

export default class TrayEntry
{
    constructor(scene)
    {
        //super(scene);

        this.scene = scene;
        
        this.SlideIncrement = 0;
        this.ReturnGroup = this.scene.add.group();
    }

    PaintEntry()
        {
            var TintButton = [];
            var SizeList = [];
            var SizeInstructions;
            var i;

            var SizeSelectorX;
            var SizeLocations = [45, 37, 30, 23, 17];
            const Gap = 16;
            var CurrentTotal = 93;

            SizeInstructions = ABCyaPhaser.Text.addText(217 -this.SlideIncrement, 658, 42, 0xf9a11e, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('size'), this.scene);

            let underline = '';
            for(let x = SizeInstructions.text.length + 2; x > 0; x--) {
              underline += '_'
            }
            const sizeUnderline = ABCyaPhaser.Text.addText(217 -this.SlideIncrement, SizeInstructions.getBottomCenter().y - 16, 42, 0xf9a11e, FontKeys._snigletregular, underline, this.ReturnGroup);
            this.ReturnGroup.add(SizeInstructions);

            for (i=0; i<10;i++)
            {
                TintButton[i] = this.scene.addImage(180 -this.SlideIncrement, 50  + ((i)* 62), "Cake Color/Clr_"+(20-i));
                TintButton[i].Number = 20 - i;
                TintButton[i].setScale(.75,.75);
                if(i === 4)TintButton[i].setTint(0xfaf9eb);
                if (i == 0)
                {
                    TintButton[i].setScale(.5,.5);
                    this.scene.PressedDrawButton = TintButton[i]; 
                }
                TintButton[i].on('pointerdown',function()
                {
                    if ((this.Number) != this.scene.PrevNumber && this.scene.IsPaused === false)
                    {
                        this.scene.playSound("button_menu_click");
                        this.scene.addTween(this, 100, {scale: .5},Phaser.Math.Easing.Quadratic.InOut);
                        //this.setScale(.5,.5);
                        this.scene.PrevNumber = this.Number;
                        this.scene.SetBrushTint(this.Number,this);
                    }
                });
                TintButton[i].setInteractive();
            }

            for (i=0; i<10;i++)
            {
                TintButton[i+10] = this.scene.addImage(255 -this.SlideIncrement, 50 + ((i)* 62), "Cake Color/Clr_"+(10-i));
                TintButton[i+10].Number = 10-i;
                TintButton[i+10].setScale(.75,.75);
                
                TintButton[i+10].on('pointerdown',function()
                {
                    if ((this.Number) != this.scene.PrevNumber && this.scene.IsPaused === false)
                    {
                        this.scene.playSound("button_menu_click");
                        this.scene.addTween(this, 100, {scale: .5},Phaser.Math.Easing.Quadratic.InOut);
                        this.scene.PrevNumber = this.Number;
                        this.scene.SetBrushTint(this.Number,this);
                    }
                });
                TintButton[i+10].setInteractive();
                //this.PaintGroup.add(TintButton[i]);
            }

            for(i=0;i<5;i++)
            {
                SizeSelectorX = CurrentTotal + Gap + (SizeLocations[i]/2);
                SizeList[i] = this.scene.addImage(SizeSelectorX - this.SlideIncrement, 715, "Paint/Size_"+(5-i));
                CurrentTotal += Gap + SizeLocations[i];
                if(i === 2)
                {
                    SizeList[i].setTint(0x424242);
                    this.scene.PressedSizeButton = SizeList[i];
                }
                SizeList[i].number = i
                SizeList[i].setInteractive();
                //this.PaintGroup.add(SizeList[i]);
                SizeList[i].on('pointerdown',function()
                {
                    this.scene.playSound("button_menu_click");
                    this.scene.CircleSize(this);
                });
            }

            this.ReturnGroup.addMultiple(SizeList);
            this.ReturnGroup.addMultiple(TintButton);

            return this.ReturnGroup;

            // this.input.on('pointerdown',(pointer,localX,localY,event)=> {
                
            //     if (pointer.isDown && this.IsDrawing === true && pointer.x > 442 && pointer.x < 924 && pointer.y < 659 && pointer.y > 269 && this.IsPaused === false && PaintMethod === 0)
            //     {
            //         this.SoundCheck("place_item");
            //     }
            // });

            //  this.scene.input.on('pointermove',(pointer)=> {
        
            //  }, this);

            // this.input.on('pointerup',()=>
            // {
            //     if(this.LogDraw)
            //     {
            //         this.NeedNewRender = true;
            //         this.AddRenderTextureCheck();
            //         this.CreateDrawBackLog(this.DrawOn[this.DrawOn.length-1],DrawLog);
            //         this.LogDraw = false;
            //     }
            // });
        }

    IcingEntry(ActiveTab)
        {
            var i;
            const NumberOfItems = 7;
            const Sections = 716/NumberOfItems;
            var IcingArray = [];
            var SendParams = {};
            var IcingCheck = 'null';
            var Icing;
            
            for (i=0;i<NumberOfItems;i++)
            {
                
                IcingArray[i] = this.scene.addImage(220-this.SlideIncrement,30+((Sections/2)+2)+(i*Sections),"Icing/Icing_"+(i+1));
                IcingArray[i].setScale(.30,.25);
                IcingArray[i].setInteractive();
                IcingArray[i].on('pointerdown',function(pointer)
                {
                    if (this.scene.Icing != 'null') 
                    {
                        IcingCheck = this.scene.Icing.frame.name;
                    }
                    else if(this.scene.Icing === 'null' && IcingCheck != 'null')
                    {
                        IcingCheck = 'null';
                    }
                    
                    if (this.frame.name != IcingCheck)
                    {
                        //console.log("Placing now");
                        switch(this.frame.name)
                        {
                            case "Icing/Icing_1":
                                SendParams = {scale: .89};
                                break;
                            case "Icing/Icing_4":
                                SendParams = {scale: .95};
                                break;
                            case "Icing/Icing_5":
                                SendParams = {scale: .95};
                                break;
                            case "Icing/Icing_6":
                                SendParams = {scale: .95};
                                break;
                            case "Icing/Icing_7":
                                SendParams = {scale: 1.09};
                                break;
                            default:
                                SendParams = {scale: .9};
                                break;
                        }

                        SendParams.depth = this.scene.DepthList.Toppings;

                        Icing = this.scene.addImage(0,0,this.frame.name).setScale(SendParams.scale);

                        const CakeCenterTop = this.scene.Cake.getTopCenter();
                        const IcingNumber = (Number(Icing.frame.name.slice(-1))-1);
                        //console.log(IcingNumber);
                        var Placement = 
                        [   
                            [0,97],
                            [.5,72],
                            [1,67],
                            [.5,69],
                            [.5,84],
                            [-5.5,67],
                            [.5,94]
                        ];

                        Icing.setDepth(Icing.scene.DepthList.Icing);

                        Icing.x = CakeCenterTop.x + (Placement[IcingNumber][0]);
                        Icing.y = CakeCenterTop.y + (Placement[IcingNumber][1]);


                        this.scene.Constraints.PlaceCheck(Icing,{Active:this.scene.Active,Original:this});
                        //this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},SendParams);
                    }
                    
                });
            }

            this.ReturnGroup.addMultiple(IcingArray);
            return this.ReturnGroup;
        }

    PatternEntry()
        {
            var i;
            const NumberOfItems = 8;
            const Sections = 716/NumberOfItems;
            var PatternArray = [];
            for (i=0;i<NumberOfItems;i++)
            {
                PatternArray[i] = this.scene.addImage(225-this.SlideIncrement,30+((Sections/2)+2)+(i*Sections),"Patterns/Pttrn_"+(i+1));
                if (i > 2)PatternArray[i].y += 20;
                if (i === 3)PatternArray[i].y -= 10;
                PatternArray[i].setScale(.75);
                PatternArray[i].setInteractive();
                PatternArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                });
            }
            this.ReturnGroup.addMultiple(PatternArray);
            return this.ReturnGroup;
        }

    DecorEntry()
        {
            var DecorArray = [];
            var DecorLocations = [
            [272.30455478807636,478.26784565950436],
            [161.56778241351572,489.53900111879295],
            [198.4553842647245,270.2637949108154],
            [164.64174923444978,413.7148643926699],
            [290.6743888927468,393.2218544666907],
            [178.98692773214208,564.338487348617],
            [280.4278328229665,269.23914441451643],
            [294.7730113206588,573.5603418153078],
            [173.86364969725193,644.2612260599361],
            [284.5264552508786,643.236575563637],
            [171.81433848329593,723.159314274956],
            [280.4278328229665,719.0607122897601],
            [272.23058796714236,133.9852789030536],
            [174.88830530422996,133.98527890305363],
            [173.86364969725193,48.93928771023987],
            [276.3292103950544,50.98858870283779]];

            for(let x = 0; x < 16;x++)
            {
                DecorArray[x] = this.scene.addImage(DecorLocations[x][0] - this.SlideIncrement,DecorLocations[x][1], 'Toppings/Dcr_'+(x+1));
                DecorArray[x].setScale(.75);
                DecorArray[x].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                });
                DecorArray[x].setInteractive();
            }

            this.ReturnGroup.addMultiple(DecorArray);
            return this.ReturnGroup;
        }

    FlowerEntry()
        {
            var i;
            var FlowerArray = [];
            const NumberOfItems = 10;
            const Sections = 756/NumberOfItems;

            for (i=0; i<10;i++)
            {
                FlowerArray[i] = this.scene.addImage(179-this.SlideIncrement,6+((Sections/2)+2)+(i*Sections), "Flowers/Flwr_"+(i+1));
                FlowerArray[i].setScale(.75);
                FlowerArray[i].setInteractive();
                FlowerArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                });
            }

            for (i=10; i<20;i++)
            {
                FlowerArray[i] = this.scene.addImage(276-this.SlideIncrement,4+(((Sections/2)+2)+((i-10)*Sections)), "Flowers/Flwr_"+(i+1));
                FlowerArray[i].setScale(.75);
                FlowerArray[i].setInteractive();
                FlowerArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                });
            }

            this.ReturnGroup.addMultiple(FlowerArray);

            return this.ReturnGroup;
        }


        CandleEntry()
        {
            var i;
            var CandleArray = [];
            var FireArray = [];
            const NumberOfItems = 4;
            const Sections = 756/NumberOfItems;

            for (i=0; i<4;i++)
            {
                CandleArray[i] = this.scene.addImage(179-this.SlideIncrement,16+((Sections/2)+2)+(i*Sections), "Candles/Cndl_"+(i+1));
                FireArray[i] = this.scene.addImage(179-this.SlideIncrement,CandleArray[i].y - ((CandleArray[i].height*.75)/2), "Candles/Cndl_Fire_"+(i+1));
                
                //console.log(CandleArray[i].height); 

                FireArray[i].setScale(.75);
                CandleArray[i].setScale(.75);

                FireArray[i].setOrigin(.5,1);

                this.scene.Animations.CandleFireIdleTween(FireArray[i]);

                if (i === 1)
                {
                    FireArray[i].x += 1;
                }

                CandleArray[i].setInteractive();

                //CandleArray[i].input.hitArea.setTo(-20,-FireArray[i].height, CandleArray[i].width + 50, CandleArray[i].height + FireArray[i].height);

                CandleArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                });
                
            }

            for (i=4; i<8;i++)
            {
                CandleArray[i] = this.scene.addImage(278-this.SlideIncrement,16+((Sections/2)+2)+((i-4)*Sections), "Candles/Cndl_"+(i+1));
                FireArray[i] = this.scene.addImage(278-this.SlideIncrement,CandleArray[i].y - ((CandleArray[i].height*.75)/2), "Candles/Cndl_Fire_"+(i+1));

                FireArray[i].setScale(.75);
                CandleArray[i].setScale(.75);
                //FireArray[i].y -= (((FireArray[i].height * .60)/2)+5);

                CandleArray[i].setInteractive();

                if (i != 5)
                {
                    //CandleArray[i].input.hitArea.setTo(-20,-FireArray[i].height, CandleArray[i].width + 50, CandleArray[i].height + FireArray[i].height);
                }
                else
                {
                    //CandleArray[i].input.hitArea.setTo(-20,-FireArray[i].height, CandleArray[i].width + 50, CandleArray[i].height + FireArray[i].height);
                }

                CandleArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                });
                //this.CandleGroup.add(CandleArray[i]);
                //this.CandleGroup.add(FireArray[i]);
                //FireArray[i].setOrigin(.5,1);
                //this.CandleFireIdleTween( FireArray[i]);

                if (i != 7)
                {
                    FireArray[i].setOrigin(.5,1);
                    //FireArray[i].y -= (((FireArray[i].height * .60)/2)+5);
                    this.scene.Animations.CandleFireIdleTween(FireArray[i]);
                }
                else
                {
                    //FireArray[i].x += 5;
                    FireArray[i].setOrigin(.45,.49);
                    this.scene.addRepeatingEvent(100,()=>
                    {
                        //console.log("Speed is 180");
                        FireArray[7].setRotation(Math.random());
                    },-1);
                }
            }

            this.ReturnGroup.addMultiple(CandleArray);
            this.ReturnGroup.addMultiple(FireArray);

            return this.ReturnGroup;
        }

        NumbersEntry(Color = "_Orange",Slide = this.SlideIncrement)
        {   
            var i;
            const DisplayNumList = [1,3,5,7,9,2,4,6,8,0];
            var NumbersArray = [];
            const NumberOfItems = 5;
            const Sections = 556/NumberOfItems;
            var YLocation;

            for (i=0; i<5;i++)
            {
                YLocation = 25+((Sections/2)+2)+(i*Sections);
                NumbersArray[i] = this.scene.addImage(178-Slide,YLocation, "Numbers/"+(DisplayNumList[i])+Color);
                NumbersArray[i].setInteractive();
                NumbersArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                    //this.scene.TrayEntry.PlaceTools.hello();
                });
                //this.NumbersGroup.add(NumbersArray[i]);
            }
            
            for (i=5; i<10;i++)
            {
                YLocation = 25+((Sections/2)+2)+((i-5)*Sections);
                NumbersArray[i] = this.scene.addImage(270-Slide, YLocation, "Numbers/"+(DisplayNumList[i])+Color);
                //NumbersArray[i].setScale(.5);
                NumbersArray[i].setInteractive();
                NumbersArray[i].on('pointerdown',function(pointer)
                {
                    this.scene.PlaceTools.CreateCopy(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                });
                //this.NumbersGroup.add(NumbersArray[i]);
            }

            this.ReturnGroup.addMultiple(NumbersArray);

            this.AddColors("Numbers",this.ReturnGroup,Slide,Color);

            return this.ReturnGroup; 
        }

        LettersEntry(Color = "_Orange", Slide = this.SlideIncrement)
        {
            var i = 0;
            let LettersStock;
            let fontSize = 82;
            if (ABCyaLib.Environment.instance.locale !== 'es-US'){
              LettersStock = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
            }
            else {
              LettersStock = ["A","Á","B","C","D","E","É","F","G","H","I","Í","J","K","L","M","N","Ñ","O","Ó","P","Q","R","S","T","U","Ú","Ü","V","W","X","Y","Z"];
              fontSize = 72;
            }
            var LettersArray = [];

            const NumberOfItems = 9;
            const Sections = 571/NumberOfItems;
            var YLocation;

            let strokeColor;

            switch(Color){
              case "_Red":
                strokeColor = '#ef5243';
                break;
              case "_Orange":
                strokeColor = '#f9a11e';
                break;
              case "_Green":
                strokeColor = '#90d844';
                break;
              case "_Blue":
                strokeColor = '#41c3d8';
                break;
              case "_Purple":
                strokeColor = '#e75cd7';
                break;
              case "_Black":
                strokeColor = '#424242';
                break;
            }

            if(LettersStock.length > 26) {
              for (let firstl = 0; firstl < 9; firstl++)
              {
                  YLocation = 14+(((Sections/2)+2)+((firstl)*Sections));

                  LettersArray[i] = ABCyaPhaser.Text.addText(160-Slide,YLocation, fontSize, 0xffffff, FontKeys._snigletregular, LettersStock[i], this.scene).setStroke(strokeColor, 10);
                  LettersArray[i + 1] = ABCyaPhaser.Text.addText(208-Slide,YLocation, fontSize, 0xffffff, FontKeys._snigletregular, LettersStock[i+1], this.scene).setStroke(strokeColor, 10);
                  
                  if(LettersStock[i+2] !== undefined)
                  {
                    LettersArray[i + 2] = ABCyaPhaser.Text.addText(256-Slide,YLocation, fontSize, 0xffffff, FontKeys._snigletregular, LettersStock[i+2], this.scene).setStroke(strokeColor, 10);

                  }
                  if(LettersStock[i+3] !== undefined)
                  {
                    LettersArray[i + 3] = ABCyaPhaser.Text.addText(304-Slide,YLocation, fontSize, 0xffffff, FontKeys._snigletregular, LettersStock[i+3], this.scene).setStroke(strokeColor, 10).setPadding(0, 3, 5);

                  }

                  i += 4;
              }
            }
            else {

              for (let firstl = 0; firstl < 9; firstl++)
              {
                  YLocation = 14+(((Sections/2)+2)+((firstl)*Sections));

                  LettersArray[i] = ABCyaPhaser.Text.addText(165-Slide,YLocation, fontSize, 0xffffff, FontKeys._snigletregular, LettersStock[i], this.scene).setStroke(strokeColor, 10);
                  LettersArray[i + 1] = ABCyaPhaser.Text.addText(233-Slide,YLocation, fontSize, 0xffffff, FontKeys._snigletregular, LettersStock[i+1], this.scene).setStroke(strokeColor, 10);
                  
                  if(LettersStock[i+2] !== undefined)
                  {
                    LettersArray[i + 2] = ABCyaPhaser.Text.addText(299-Slide,YLocation, fontSize, 0xffffff, FontKeys._snigletregular, LettersStock[i+2], this.scene).setStroke(strokeColor, 10);

                  }

                  i += 3;
              }
            }

            LettersArray.forEach((Image)=>
            {
                Image.setScale(.75);
                Image.setInteractive();
                Image.on('pointerdown', function(pointer)
                    { 
                        this.scene.PlaceTools.CreateCopyText(this,pointer,{Active:this.scene.Active,Original:this},{depth: this.scene.DepthList.Toppings});
                    });
            });

            this.ReturnGroup.addMultiple(LettersArray);

            this.AddColors("Letters",this.ReturnGroup,Slide,Color);

            return this.ReturnGroup;

        }

        AddColors(Which1,ColorGroup,Slide,SentColor)
        {
            let Buttons = [];
            var Color;
            var Group;

            // Buttons[0] = this.scene.addImage(228 - Slide,613, "Numbers & Letters/Color_text");
            Buttons[0] = ABCyaPhaser.Text.addText(228 - Slide,606, 42, 0xf9a11e, FontKeys._snigletregular, ABCyaPhaser.Localization.instance.getLocalizedString('color'), this.scene);

            let underline = '';
            for(let x = Buttons[0].text.length + 2; x > 0; x--) {
              underline += '_'
            }
            const sizeUnderline = ABCyaPhaser.Text.addText(228 - Slide,617, 42, 0xf9a11e, FontKeys._snigletregular, underline, ColorGroup);
            
            Buttons[1] = this.scene.addImage(158 - Slide,672, "Numbers & Letters/Color_Red").setData('Color', "_Red");
            Buttons[2] = this.scene.addImage(232 - Slide,672, "Numbers & Letters/Color_Orange").setData('Color',"_Orange");
            Buttons[3] = this.scene.addImage(303 - Slide,672, "Numbers & Letters/Color_Green").setData('Color',"_Green");
            Buttons[4] = this.scene.addImage(158 - Slide, 731, "Numbers & Letters/Color_Blue").setData('Color',"_Blue");
            Buttons[5] = this.scene.addImage(232 - Slide, 731, "Numbers & Letters/Color_Purple").setData('Color',"_Purple");
            Buttons[6] = this.scene.addImage(303 - Slide, 731, "Numbers & Letters/Color_Black").setData('Color',"_Black");  

            ColorGroup.addMultiple(Buttons);

            for(let i = 1; i < 7; i++)
            {
                Buttons[i].on('pointerdown', ()=>
                {
                    this.scene.playSound("button_menu_click");
                    Color = Buttons[i].getData('Color');
                    ColorGroup.clear(true, true);
                    OnPress(Which1,this);
                });
                if (Buttons[i].getData('Color') != SentColor)
                {
                    Buttons[i].setInteractive();
                }
            }
            
            function OnPress(Which1,Scope)
            {
                if (Which1 === "Letters") 
                {
                    Group = Scope.LettersEntry(Color,0);
                }
                else
                {
                    Group = Scope.NumbersEntry(Color,0);
                }

                Group.getChildren().forEach((Child)=>
                {
                    Child.setDepth(Scope.scene.DepthList.PaintTool);
                });
            }
        }

    }